// extracted by mini-css-extract-plugin
export var closemodal = "index-middle-module--closemodal--2a0cd";
export var modal = "index-middle-module--modal--082ed";
export var modalcontent = "index-middle-module--modalcontent--02327";
export var overlay = "index-middle-module--overlay--338e8";
export var popup = "index-middle-module--popup--f68d2";